import { Outlet, useNavigate } from 'react-router-dom'
import { useEffect } from 'react'
import { MemberApi } from '@/domains/auth/api'
import { wagmiGetAccount } from '@/shared/lib/wagmi/api/wagmiGetAccount.ts'

export function AuthorizedRoute() {
  const navigate = useNavigate()

  useEffect(() => {
    async function _() {
      const account = wagmiGetAccount()
      const memberData = await MemberApi.fetchInfo()

      if (!account.isConnected || !memberData) {
        navigate('/game', { replace: true })
      }
    }

    _()
  }, [])

  return <Outlet />
}
